<template>
    <div class="table-responsive">
        <table class="table b-table table-striped table-hover">
            <tbody>
                <tr v-for="(item, index) in items" :key=index>
                    <th>{{ item.key }}</th>
                    <td>
                        <slot :name=item.key :value="item.value">{{ item.value }}</slot>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        items: Array
    }
}
</script>
